(() => {
  if (window.__diggnHomeRoutinePicksBooted) return;
  window.__diggnHomeRoutinePicksBooted = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const prepare = (root) => {
    if (!root || root.dataset.routinePickImagesPrepared === 'true') return;
    root.dataset.routinePickImagesPrepared = 'true';

    const images = Array.from(root.querySelectorAll('[data-dg-deferred-src]'));
    if (!images.length) return;

    const hydrate = () => {
      images.forEach((image) => {
        const source = image.dataset.dgDeferredSrc;
        if (!source || image.dataset.hydrated === 'true') return;
        image.dataset.hydrated = 'true';
        image.src = source;
      });
    };

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      hydrate();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      hydrate();
      observer.disconnect();
    }, { rootMargin: '1200px 0px', threshold: 0.01 });

    observer.observe(root);
  };

  const init = (scope = document) => {
    if (scope.matches && scope.matches('#DiggnHomeQuickShop')) prepare(scope);
    scope.querySelectorAll('#DiggnHomeQuickShop').forEach(prepare);
  };

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
})();
